import { defineStore } from "pinia"
import { ref } from "vue"

interface Message {
    text: string
    color: 'success' | 'error' | 'warning' | 'info'
}

export const useMessagesStore = defineStore('messages', () => {
    const queue = ref<Message[]>([])
    function add(message: Message) {
        queue.value.push(message)
    }

    return { queue, add }
})